module.exports = __webpack_public_path__ + "static/media/topIcon.554f792a.png";